<style scoped>
.setting-onesignal-block .save-btn {
    text-align: center;
    position: relative;
    margin:  10px auto;
}

.onesignal-setting-block .open-onesignal-setting-modal-btn-block {
    padding: 10px 0 0 0;
}

.onesignal-setting-block input {
    padding-left: 15px;
}
</style>

<template>
<div class="col-12 row clock-block input-setting-block onesignal-setting-block">
    <div class="offset-2 col-1 elips"></div>
    <div class="col-6 item-name">
        Настройки PUSH сообщений - Onesignal
    </div>
    <div class="col-3 open-onesignal-setting-modal-btn-block">
        <a class="aquazor-btn-small open-onesignal-setting-modal-btn" @click="showModal">Изменить</a>
    </div>
    <b-modal size="lg" ref="settingModal" hide-footer v-model="show_modal">
        <div class="setting-onesignal-block text-center container-fluid">
            <h3>Настройки Onesignal</h3>
            <loader-component v-if="modal_loader" class="col-12 row"></loader-component>
            <div v-if="!modal_loader">
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        OneSignal AppID
                    </div>
                    <div class="col-9">
                        <input v-bind:class="{fail: msg_onesignal_app_id}" v-model="onesignal_app_id" type="text" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        REST API Key
                    </div>
                    <div class="col-9">
                        <input v-bind:class="{fail: msg_rest_api_key}" v-model="rest_api_key" type="text" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row">
                    <a class="aquazor-btn save-btn" @click="saveOneSignalSetting">Сохранить</a>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import loader from './loader.vue'

export default {
    data() {
        return {
            show_modal: false,
            modal_loader: true,
            onesignal_app_id: null,
            msg_onesignal_app_id: null,
            rest_api_key: null,
            msg_rest_api_key: null
        }
    },
    methods: {
        showModal() {
            get_onesignal_setting(this)
            this.$refs.settingModal.show()
        },
        hideModal() {
            this.$refs.settingModal.hide()
        },
        saveOneSignalSetting() {
            save_onesignal_setting(this)
        }
    },
    components: {
        'loader-component': loader
    },
    watch: {
        show_modal: function (show_modal_value) {
            console.log(show_modal_value)
            if (!show_modal_value) {
                this.modal_loader = true
            }
        }
    },
}

function save_onesignal_setting(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('onesignal_app_id', vue_obj.onesignal_app_id)
        post_data.set('rest_api_key', vue_obj.rest_api_key)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor_settings/set_setting_onesignal',
                data: post_data
            })
            .then(function (response) {
                console.log(response.data)
                vue_obj.hideModal()
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
    }
}

function get_onesignal_setting(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('setting_name', 'onesignal')
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor_settings/get_setting',
                data: post_data
            })
            .then(function (response) {
                if (!!response.data.settings.onesignal_app_id) {
                    vue_obj.onesignal_app_id = response.data.settings.onesignal_app_id
                }
                if (!!response.data.settings.rest_api_key) {
                    vue_obj.rest_api_key = response.data.settings.rest_api_key
                }
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
            .finally(function (request) {
                vue_obj.modal_loader = false
            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/onesignal_settings.vue